import React, {useState} from "react";
import {Button, Dialog} from "@mui/material";
import {observer} from "mobx-react";
import ProcedurePreviewPlayer from "../RunProcedure/ProcedurePreviewPlayer";
import './modal.scss'
import CloseIcon from "@mui/icons-material/Close";
import {useStores} from "../../Hooks";

const ProcedurePreviewModal = observer(props => {
    const {modalStore, generalStore, procedureStore} = useStores();
    const [backgroundColorRight, setBackgroundColorRight] = useState(null);
    const [backgroundColorLeft, setBackgroundColorLeft] = useState(null);
    const [backgroundImageAddress, setBackgroundImageAddress] = useState(null);
    const [isBackgroundColor, setIsBackgroundColor] = useState(null);
    const [isStreamable, setIsStreamable] = useState(null);
    const [dataFetched, setDataFetched] = useState(false);

    const {procedure, selectedNodeId, fromEditor} = modalStore.modalData;

    const isTempHeight = generalStore.sliderRefreshProcedureFlag;

    if (!procedure) {
        return null;
    }

    async function onEnter() {
        const [{
            webBackgroundColorRight: backgroundColorRight,
            webBackgroundColorLeft: backgroundColorLeft,
            webBackgroundImageAddress: backgroundImageAddress,
            webIsBackgroundColor: isBackgroundColor,
            isStreamable
        }] = await Promise.all([
            generalStore.getPlayerSettings()
        ]);
        setBackgroundColorRight(backgroundColorRight);
        setBackgroundColorLeft(backgroundColorLeft);
        setBackgroundImageAddress(backgroundImageAddress);
        setIsBackgroundColor(isBackgroundColor);
        setIsStreamable(isStreamable);
        setDataFetched(true);
    }

    function closeModal() {
        modalStore.modalData.procedure = null;
        if (modalStore.modalData.onPreviewEnd) {
            modalStore.modalData.onPreviewEnd();
            modalStore.modalData.onPreviewEnd = null;
        }
        modalStore.resetModalData();
        modalStore.isProcedurePreviewModalOpen = false;
        procedureStore.play3d = false;
    }


    return (
        <Dialog
            TransitionProps={{
                onEnter
            }}
            onClose={closeModal}
            open={modalStore.isProcedurePreviewModalOpen}
            maxWidth='lg'
            fullWidth
            className={'dialog procedure-preview-dialog' + (isTempHeight ? ' temp-height' : '')}
        >
            <Button disableElevation disableFocusRipple disableRipple disableTouchRipple className='close-button'
                    onClick={closeModal}>
                <CloseIcon htmlColor='white'/>
            </Button>
            <ProcedurePreviewPlayer
                procedure={procedure}
                selectedNodeId={selectedNodeId}
                backgroundColorRight={backgroundColorRight}
                backgroundColorLeft={backgroundColorLeft}
                backgroundImageAddress={backgroundImageAddress}
                isBackgroundColor={!!isBackgroundColor}
                isStreamable={!!isStreamable}
                dataFetched={dataFetched}
                fromEditor={fromEditor}
            />
        </Dialog>
    )
});

export default ProcedurePreviewModal;
